export default [
  {
    title: 'Ana Sayfa',
    route: 'Portal',
    icon: 'HomeIcon',
  },
  {
    title: 'Kurumsal',
    route: 'Company',
    icon: 'BriefcaseIcon',
  },
  {
    title: 'Eğitimler',
    route: 'Education',
    icon: 'BookOpenIcon',
  },
  {
    title: 'Doküman Arşivi',
    route: 'Documents',
    icon: 'BookIcon',
  },
  {
    title: 'Öğrenilmiş Dersler',
    route: 'LessonsLearned',
    icon: 'BookOpenIcon',
  },
  {
    title: 'Fotoğraf Galerisi',
    route: 'Gallery',
    icon: 'CameraIcon',
  },
  {
    title: 'Toplantı Takvimi',
    route: 'MeetingCalendar',
    icon: 'CalendarIcon',
  },
  {
    title: 'Personeller',
    route: 'Employees',
    icon: 'UsersIcon',
  },
]
